import React, { useState } from "react";
import "../../assets/style/eegisterProvider.css";
import { Button } from "@mui/material";
import FundSubscriberProfileTable from "../../components/Table/FundSubscriberProfileTable";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ApiCall from "../../utils/Api";
import { toast } from "react-toastify";

const FundSubscriberDataUnit = () => {
  const navigate = useNavigate();
  const [ButData, setButData] = useState({
    SDL: "",
    Instrumente: "",
    TimeModus: "",
    Market: "",
    Time: "",
  });

  const AddwalletAddress = async () => {
    try {
      // First check if MetaMask is connected
      if (!window.ethereum) {
        toast.error("MetaMask is not installed. Please install MetaMask to add wallet addresses.");
        return;
      }

      let connectedAccounts = [];
      try {
        connectedAccounts = await window.ethereum.request({ method: 'eth_accounts' });
      } catch (error) {
        // MetaMask not connected
      }

      // If no accounts are connected, show message to connect first
      if (connectedAccounts.length === 0) {
        toast.error("Please connect your MetaMask wallet first before adding wallet addresses.");
        return;
      }

      // MetaMask is connected, proceed with adding wallet address
      const result = await Swal.fire({
        title: "Add Wallet Address",
        html: `
          <input id="walletid" class="swal2-input" placeholder="Enter wallet address">
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Add Wallet',
        cancelButtonText: 'Cancel',
        preConfirm: async () => {
          let Newwalletid = document.getElementById("walletid").value;
          if (!Newwalletid) {
            Swal.showValidationMessage("Please enter a wallet address");
            return false;
          }

          // Verify the entered address is one of the connected accounts
          const newwalletid = connectedAccounts.filter((item) => item.toLowerCase() === Newwalletid.toLowerCase());
          if (newwalletid.length == 0) {
            Swal.showValidationMessage("This address is not connected in your MetaMask wallet");
            return false;
          }

          try {
            const data = await ApiCall.SECURE_API.post("/user/AddWalletAddress", {
              "newWalletAddress": `${Newwalletid}`
            });
            return data;
          } catch (error) {
            Swal.showValidationMessage(error.response?.data?.message || "Failed to add wallet address");
            return false;
          }
        }
      });

      if (result.isConfirmed && result.value) {
        toast.success(result.value.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while adding wallet address");
    }
  };

  return (
    <div style={{ width: "100%", backgroundColor: "#F3F4F8" }}>
      <span className="RegisterProviderText">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ paddingLeft: 20 }}>Profile</span>
        </div>
      </span>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: 900,
        }}
      >
        <div style={{ width: "98%", marginTop: 40 }}>
          <FundSubscriberProfileTable />
        </div>
        <div style={{ width: "90%", padding: 10 }}>
          <Button onClick={AddwalletAddress} variant='contained' type='button'>
            Add Wallet Address +
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FundSubscriberDataUnit;
